<template>
	<v-row class='dropdown-filter py-1 ml-2'>
		<v-col :class='$vuetify.breakpoint.xsOnly ? "" : "mr-11"' class='pa-0 flex-grow-0'>
			<v-row no-gutters class='pa-0'>
				<v-col class='font-weight-bold pb-1' cols='12' style='height: 24px;'>
					Von:
				</v-col>

				<v-col cols='12'>
					<div class='d-inline-flex' style='width: 100%'>
						<select-component
							v-model='min'
							:options='min_options'
							:title='filter.label + " von:"'
							class='select light-border dropdown-filter-from-select'
							width='164px'
							height='34px'
						/>
					</div>
				</v-col>
				<v-col cols='12'>
					<div class='error--text font-weight-bold pt-1' style='height: 24px'>
						{{ minError }}
					</div>
				</v-col>
			</v-row>
		</v-col>
		<v-col class='flex-grow-0 pa-0'>
			<v-row no-gutters>
				<v-col
					class='font-weight-bold pb-1'
					:class='{
						"pl-0": $vuetify.breakpoint.xsOnly
					}'
					cols='12'
					style='height: 24px;'
				>
					Bis:
				</v-col>
				<v-col
					cols='12'
					:class='{
						"pl-0": $vuetify.breakpoint.xsOnly
					}'
				>
					<div class='d-inline-flex' style='width: 100%'>
						<select-component
							v-model='max'
							:options='max_options'
							:title='filter.label + " bis:"'
							class='select light-border dropdown-filter-till-select'
							width='164px'
							height='34px'
						/>
					</div>
				</v-col>

				<v-col cols='12'>
					<div class='error--text font-weight-bold pt-1' style='height: 24px'>
						{{ maxError }}
					</div>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import BaseFilterMixin from './BaseFilterMixin'
import SelectComponent from '../SelectComponent'

export default {
	name: 'DropdownFilter',
	components: {SelectComponent},
	mixins: [BaseFilterMixin],

	data() {
		return {
			min: '',
			max: '',
			selectedRange: [this.filter.values.find(v => v.default).value] // pass default value to the range (-1|0)
		}
	},


	computed: {
		min_options() {
			const values_without_default = this.filter.values.filter(v => !v.default)

			const default_option = {
				label: this.filter.values.find(v => v.default).label,
				value: ''
			}

			return [default_option, ...values_without_default]
		},

		max_options() {
			const values_without_default = this.filter.values.filter(v => !v.default)

			const default_option = {
				label: this.filter.values.find(v => v.default).label,
				value: ''
			}

			return [default_option, ...values_without_default]
		},

		minError() {
			if (this.min && this.min < 0) return 'Wert darf nicht unter 0 liegen'
			else if (this.min && (this.max || this.max === 0) && this.min > this.max) return 'Von darf nicht größer als bis sein'
			else return ''
		},

		maxError() {
			if (this.max && this.max < 0) return 'Wert darf nicht unter 0 liegen'
			else if (this.max && (this.min || this.min === 0) && this.max < this.min) return 'Bis darf nicht kleiner als von sein'
			else return ''
		},

		hasError() {
			return (this.minError || this.maxError)
		}
	},

	watch: {
		min() {
			if (!this.hasError) this.selectedRange = [this.min, this.max]
		},

		max() {
			if (!this.hasError) this.selectedRange = [this.min, this.max]
		},

		selectedRange() {
			const min = this.selectedRange[0]
			const max = this.selectedRange[1]

			if (!min && !max) this.selectedRange = this.filter.values.find(v => v.default) // pass default value to the range (-1|0)
			else if (!min || !max) {
				const values_without_default = this.filter.values.filter(v => !v.default)

				if (!min) this.selectedRange[0] = Math.min.apply(Math, values_without_default.map(function (o) {
					return o.value
				}))
				else this.selectedRange[1] = Math.max.apply(Math, values_without_default.map(function (o) {
					return o.value
				}))
			}

			this.updateFilter([this.selectedRange])
		},
	},

	mounted() {
		let vals = this.filter.selectedValues

		if (vals && vals.length) {
			if (Array.isArray(vals[0])) vals = vals[0]

			if (vals.length < 2) {
				this.min = ''
				this.max = ''
			} else {
				this.min = vals[0] ?? vals[0].value
				this.max = vals[1] ?? vals[1].value
			}
		}
	},
}
</script>

<style lang='scss'>
.dropdown-filter {

  .dropdown-filter-till-select, .dropdown-filter-from-select {
      fieldset {
        border: 0 !important;
      }
      .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
        height: 32px!important;
        max-height: 32px!important;
        min-height: 32px!important;
      }
      .v-input__append-inner {
        width: 28px !important;
        height: 26px !important;

        .v-icon {
          font-size: 19px !important;
        }
        .v-input__icon {
          margin-left: -2px;
          margin-top: 1px;
          width: 28px !important;
          height: 26px !important;
          border-radius: 2px;
          box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.28) !important;
          border: 1px solid rgba(185, 185, 185, 0.4) !important;
        }
      }
    .v-select__selections {
      font-size: 12px;
    }
  }
}
</style>